// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/fatture?societaId&stato&tipoFattura&commessaId&nominativoId',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","societaId":"number","sedeId":"number|null","nominativoId":"number|null","commessaId":"number|null","tipoFattura":"IMMEDIATA|DIFFERITA","stato":"BOZZA|EMESSA|ANNULLATA","numero":"string|null","dataDocumento":"string|null","dataEmissione":"string|null","clienteRagioneSociale":"string|null","totaleImponibile":"number","totaleIva":"number","totale":"number","commessa":{"id":"number","numero":"string","descrizione":"string"},"tipoDocumento":{"id":"number","codice":"string","nome":"string"},"_count":{"righe":"number"}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
